import type { Components, CreatableOptionType } from './Select.types'
import SelectCreatableOption from './SelectCreatableOption'
import SelectEmpty from './SelectEmpty'
import SelectOption from './SelectOption'

const defaultComponents = {
  Option: SelectOption,
  Empty: SelectEmpty,
  CreatableOption: SelectCreatableOption as CreatableOptionType,
}

export function getComponents(components?: Components): Required<Components> {
  return { ...defaultComponents, ...components }
}
